var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.83 2.597 0.5716 0.5716c0.444 0.444 0.444 1.162 0 1.601l-1.375 1.379-2.178-2.178 1.375-1.375c0.444-0.444 1.162-0.444 1.601 0zm-10.92 9.32 6.339-6.344 2.178 2.178-6.344 6.339c-0.137 0.137-0.307 0.2362-0.4913 0.2881l-2.763 0.7889 0.7889-2.763c0.05196-0.1842 0.1512-0.3543 0.2881-0.4913zm7.714-10.92-9.32 9.315c-0.411 0.411-0.7086 0.9164-0.8644 1.469l-1.351 4.724c-0.1134 0.3968-0.0048 0.8219 0.2881 1.115 0.2929 0.2929 0.718 0.4015 1.115 0.2881l4.724-1.351c0.5574-0.1606 1.063-0.4582 1.469-0.8644l9.32-9.315c1.327-1.327 1.327-3.481 0-4.809l-0.5716-0.5716c-1.327-1.327-3.481-1.327-4.809 0zm-13.47 1.842c-2.296 0-4.157 1.861-4.157 4.157v12.85c0 2.296 1.861 4.157 4.157 4.157h12.85c2.296 0 4.157-1.861 4.157-4.157v-5.291c0-0.6283-0.5054-1.134-1.134-1.134-0.6283 0-1.134 0.5054-1.134 1.134v5.291c0 1.044-0.8455 1.889-1.889 1.889h-12.85c-1.044 0-1.889-0.8455-1.889-1.889v-12.85c0-1.044 0.8455-1.889 1.889-1.889h5.291c0.6283 0 1.134-0.5054 1.134-1.134s-0.5054-1.134-1.134-1.134z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.bb86d8b927701c17c1aedd74d010f127.svg";
export { ForwardRef as ReactComponent };